


















































import { Component, Vue, Prop, Provide, Emit } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import ValidationService from "../../services/validation.service";
import VeeValidate from "vee-validate";
import container from "../../inversify.config";
import { IPublisher } from "@/models/interfaces/publisher/publisher.model.interface";
import { Publisher } from "@/models/publisher/publisher.model";
import { ResultReasonType } from "@/enums/ResultReasonType";
import { IResponseResultModel } from "@/models/interfaces/response-result.model.interface";

const PublisherManagementModule = namespace("publisherManagementModule");

@Component({
  components: {}
})
export default class PublisherCreator extends Vue {
  @PublisherManagementModule.Action public createPublisher;
  @PublisherManagementModule.Getter public publisher;

  @Provide() public publisherModel: IPublisher = new Publisher();
  @Provide() public show: boolean = false;
  @Provide() public showError: boolean = false;
  @Provide() public errorText: string = "";

  public showModal() {
    this.show = true;
  }

  public hideModal() {
    this.show = false;
    this.resetModal();
  }

  public resetModal() {
    this.publisherModel = new Publisher();
  }

  public getValidationClass(fieldName: string) {
    return container
      .get<ValidationService>(ValidationService)
      .getValidationClass(this.$validator, fieldName);
  }

  public showResultError(value: IResponseResultModel<IPublisher>) {
    if (value.reason === ResultReasonType.DuplicateName) {
      this.errorText = "I'm sorry a Publisher with the same name already exists.";
    } else {
      this.errorText = "I'm sorry an error has occurred, please try again.";
    }

    this.showError = true;
  }

  public redirectToPublisher() {
    this.hideModal();
    this.$router.push({
      name: "Publisher",
      params: { id: this.publisher.publisherId }
    });
  }

  private submitForm() {
    this.$validator.validateAll().then((valid) => {
      if (valid) {
        this.createPublisher(this.publisherModel).then((value) => {
          if (value.success) {
            this.redirectToPublisher();
          } else {
            this.showResultError(value);
          }
        });
      }
    });
  }
}
